import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(redirects)/bak/admin/ima')({
  component: () => <Navigate replace search to="/bo/admin/ima" />,
})
